<script setup lang="ts">
import SearchBarAccordion from "@/components/SearchBar/SearchBarAccordion/SearchBarAccordion.vue";
import { searchBarItems, searchTerm } from "@/globalConsts/searchBarItems";
import RangeInputDuration from "@/components/RangeInput/RangeInputDuration.ce.vue";
import { useSearchStore } from "@/stores/search";
import DateRangePicker from "@/components/DateRangePicker/DateRangePicker.vue";
import QuickSearchInput from "@/components/QuickSearch/QuickSearchInput.vue";
import { storeToRefs } from "pinia";

defineProps({
    openStep: {
        type: Number,
        default: 0,
    },
    isOpen: {
        type: Boolean,
        default: false,
    },
    values: {
        type: Object,
        required: true,
    },
});

const store = useSearchStore();
const { resetSearchBarParameter } = store;
const emit = defineEmits(["nextStep", "setStep", "search", "searchTerm"]);
const components: { [index: string]: any } = { // eslint-disable-line
    DateRangePicker: DateRangePicker,
    RangeInputDuration: RangeInputDuration,
    QuickSearchInput: QuickSearchInput,
};
const { isPalm } = storeToRefs(store);

function nextStep() {
    emit("nextStep");
}

function isLastItem(index: number) {
    return searchBarItems.length - 1 === index;
}

function resetStep(step: string) {
    if (step === searchTerm) {
        store.resetCacheSearchTerm();
    }
    resetSearchBarParameter(step);
}
</script>
<template>
    <div
        v-if="(isPalm && isOpen) || (!isPalm && openStep > 0 && isOpen)"
        class="[ c-search-bar__modal ]"
        :class="[
            { 'c-search-bar__modal--right': openStep === 2 },
            { 'c-search-bar__modal--center': openStep === 1 },
        ]"
    >
        <search-bar-accordion
            v-for="(searchBarItem, index) in searchBarItems"
            :key="'modal-item-' + searchBarItem.id"
            :class="[
                { 'is-open': openStep === index },
                'c-accordion--' + searchBarItem.id,
            ]"
            :headline="searchBarItem.title"
            :defaultText="searchBarItem.defaultValue"
            :value="values[searchBarItem.id]"
            :has-search-button="isLastItem(index)"
            @next="nextStep()"
            @click="emit('setStep', index)"
            @on-submit="emit('search')"
            @reset="resetStep(searchBarItem.id)"
        >
            <component
                v-if="searchBarItem.component"
                :key="'modal-item-' + values[searchBarItem.id]"
                :is="components[searchBarItem.component]"
                :is-mobile="isPalm"
                @next="emit('nextStep')"
            ></component>
        </search-bar-accordion>
    </div>
</template>
